import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { Box, Button } from "@mui/material";
import { useCallback, useRef, useState } from "react";
import { usePopover } from "../../../../../../utils/hooks/use-popover";
import { ColourPicker } from "../../../../../generic/components/colour-picker/colour-picker";
import { SET_DATA_TABLE_BACKGROUND_COLOUR_COMMAND } from "../../../types/commands";

import type { FC } from "react";

export const DataTableBackgroundColour: FC<{
  nodeColour: string;
  nodeKey: string;
}> = ({ nodeColour: initialColour, nodeKey }) => {
  const [editor] = useLexicalComposerContext();
  const [colour, setTempColour] = useState<string>(initialColour);
  const popover = usePopover<HTMLButtonElement>();
  const popoverInputRef = useRef<HTMLInputElement>(null);

  const setColour = useCallback(
    (c: string, skipHistory?: boolean) => {
      editor.dispatchCommand(SET_DATA_TABLE_BACKGROUND_COLOUR_COMMAND, {
        nodeKey,
        colour: c,
        skipHistory,
      });
      setTempColour(c || "");
    },
    [editor, nodeKey],
  );

  return (
    <>
      <Button
        data-analytics-id="lexical-table-menu-background-colour"
        ref={popover.anchorRef}
        onClick={popover.handleToggle}
        sx={{ color: "text.secondary" }}
        endIcon={
          <Box
            sx={{
              p: 0,
              border: "1px solid #E0E0E0",
              backgroundColor: colour,
              width: 20,
              height: 20,
            }}
          ></Box>
        }
      >
        Table background colour
      </Button>

      <ColourPicker
        popover={popover}
        colour={colour}
        onChange={setColour}
        inputRef={popoverInputRef}
      />
    </>
  );
};
